import { Box, Flex, Text } from "@chakra-ui/react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { FiMessageSquare } from "react-icons/fi";
import { IoMdAlert } from "react-icons/io";
import ReactMarkdown from "react-markdown";
import { BeatLoader } from "react-spinners";
import remarkGfm from "remark-gfm";
import { BACKGROUND_COLOR_DARK, BACKGROUND_COLOR_LIGHT } from "../../constants";

const ChatBubble = ({
  message,
  isCustomer,
  beatLoader,
  isLastMessage,
  setIsAiWritingText = () => {},
  isNewMessage,
  isRedAlertRequired,
}) => {
  const [aiText, setAiText] = useState("");
  const textPositionRef = useRef(0);
  const [isTypingComplete, setIsTypingComplete] = useState(false);

  const typeWriterEffect = useCallback(() => {
    if (textPositionRef.current < message.length) {
      setAiText(message.substring(0, textPositionRef.current + 1));
      textPositionRef.current += 1;
      requestAnimationFrame(typeWriterEffect);
    } else {
      setIsTypingComplete(true);
      setIsAiWritingText(false);
    }
  }, [message, setIsAiWritingText]);
  useEffect(() => {
    if (
      !isCustomer &&
      isLastMessage &&
      isNewMessage &&
      textPositionRef.current === 0
    ) {
      requestAnimationFrame(typeWriterEffect);
    } else {
      setAiText(message);
      setIsTypingComplete(true);
    }
  }, [isCustomer, isLastMessage, isNewMessage, typeWriterEffect]);

  return (
    <Flex justify={isCustomer ? "flex-end" : "flex-start"} px={2} my={2}>
      {!isCustomer && (
        <Box mt={2} mr={4} w="24px" h="24px">
          <>
            {isRedAlertRequired ? (
              <IoMdAlert size="24px" className="text-red-600" />
            ) : (
              <FiMessageSquare size="24px" className="text-emerald-600" />
            )}
          </>
        </Box>
      )}
      <Box
        maxW="90%"
        bg={isCustomer ? BACKGROUND_COLOR_DARK : BACKGROUND_COLOR_LIGHT}
        color={isCustomer ? "white" : "gray.800"}
        px={4}
        py={2}
        my={2}
        borderRadius="10px"
        borderBottomRightRadius={isCustomer ? "0" : "10px"}
        borderTopLeftRadius={isCustomer ? "10px" : "0"}
        wordBreak="break-word"
      >
        {beatLoader ? (
          <BeatLoader size={10} color="gray" />
        ) : (
          <Text fontSize="sm">
            {!isCustomer && isLastMessage && !isTypingComplete ? (
              aiText
            ) : (
              <ReactMarkdown
                children={message}
                remarkPlugins={[remarkGfm]}
                components={{
                  a: ({ href, children }) => (
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#3182ce", textDecoration: "underline" }}
                    >
                      {children}
                    </a>
                  ),
                  ul: ({ children }) => (
                    <ul
                      style={{ paddingLeft: "1.5rem", listStyleType: "disc" }}
                    >
                      {children}
                    </ul>
                  ),
                  ol: ({ children }) => (
                    <ol
                      style={{
                        paddingLeft: "1.5rem",
                        listStyleType: "decimal",
                      }}
                    >
                      {children}
                    </ol>
                  ),
                }}
              />
            )}
          </Text>
        )}
      </Box>
    </Flex>
  );
};

export default ChatBubble;
